module.exports = __webpack_public_path__ + "static/media/inviteTeamMembersIcon.a4c7f88c.svg";